import { PlusCircleFilled } from "@ant-design/icons";
import { Card, Col, message, Row, Select, Space } from "antd";
import { Form, Input, Button } from "antd";
import axios from "axios";
import Cookies from "js-cookie";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { GetTokenProducto, TypeIva } from "../../api/utils";
import { productStore } from "./ProductSimple";
import { baseurl, baseurlwc, credentials } from "../../api/api";
import { useProductStore } from "./LayoutProducto";
import { ContableItems } from "./ContableItems";
import { useAttributesStore } from "./Atributes";

const { Option } = Select;

export const ProductoVariante = ({ addProductSimple, variation = false }) => {
  const producto = useProductStore();
  const attributes = useAttributesStore();
  const [form] = Form.useForm();
  const [termselected, settermselected] = useState({});

  // Validar que sea un producto usando useEffect
  useEffect(() => {
    if (!producto.isProduct) {
      message.error("Solo se pueden crear productos, no servicios.");
    }
  }, [producto.isProduct]);

  // Si no es un producto, no renderizamos el formulario
  if (!producto.isProduct) {
    return null;
  }

  const onFinish = (values) => {
    producto.setData({ productstore: productStore });
    if (variation) {
      addVariante(values);
    } else {
      addProductSimple(productStore);
    }

    form.setFieldsValue({ Codigo: "" });
  };

  toast.configure();

  const onFinishFailed = (errorInfo) => {
    message.info("Por favor complete todos los campos");
  };

  const addVariante = (values) => {
    let productS = {
      ...producto.data,
      IdCategoria: producto.data.IdCategoria,
      IdSubCategoria: producto.data.IdSubCategoria,
      Categoria: producto.data.Categoria,
      SubCategoria: producto.data.SubCategoria,
      PrecioVentaConIva1: values.PrecioVentaConIva1,
      PrecioVentaConIva2: values.PrecioVentaConIva2,
      PorcentajeIva: values.PorcentajeIva,
      weight: values.weight,
      TipoProducto: 1, // Fijar explícitamente como producto
      ParametrizacionContableProducto: [
        { NumeroCuenta: values.cat0 || "", Tipo: 0 },
        { NumeroCuenta: values.cat1 || "", Tipo: 1 },
        { NumeroCuenta: values.cat2 || "", Tipo: 2 },
        { NumeroCuenta: values.cat3 || "", Tipo: 4 },
        { NumeroCuenta: values.cat4 || "", Tipo: 5 },
      ],
    };

    productS.Descripcion =
      Cookies.get("productname") + "-" + Object.values(termselected).join("-");

    const getToken = GetTokenProducto(productS);

    toast.promise(getToken, {
      pending: "Obteniendo token...",
      success: "Token obtenido 👌",
      error: "Ocurrió un error ... 🤯",
    });

    getToken.then((token) => {
      let { data } = token;
      if (data) {
        let productotosave = {
          ...productS,
          Token: data,
        };

        toast.info("Guardando producto...", {
          position: "top-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        axios
          .post(baseurl + "GuardarProductoConContabilidad", {
            ...productotosave,
          })
          .then((res) => {
            if (res.data.Exito) {
              const filteredAttributes = attributes.selected
                .map((id) => {
                  const name = values[`termselected-${id}`];
                  const group = attributes.list.find((i) => i.id === id);
                  const att = attributes.groups[id]?.find(
                    (i) => i.name === name
                  );
                  return {
                    id: group?.id,
                    option: name,
                    name: group?.name,
                    slug: att?.slug || name.toLowerCase().replace(/\s+/g, "-"),
                  };
                })
                .filter((attr) => attr.id && attr.option && attr.name);

              let producttowc = {
                regular_price: `${productotosave.PrecioVentaConIva1}`,
                price: productotosave.PrecioVentaConIva1,
                manage_stock: true,
                weight: productotosave.weight,
                dimensions: {
                  length: productotosave.dimensions.length,
                  width: productotosave.dimensions.width,
                  height: productotosave.dimensions.height,
                },
                meta_data: [
                  {
                    key: "referencia",
                    value: productotosave.Codigo,
                  },
                ],
                sku: res.data.CodigoBarras,
                attributes: filteredAttributes,
              };

              let idproduct = Cookies.get("productid");
              axios
                .post(
                  `${baseurlwc}/products/${idproduct}/variations?${credentials}`,
                  { ...producttowc }
                )
                .then((res) => {
                  if (res.data.id) {
                    toast.success("Variación guardada con éxito");
                  } else {
                    toast.error(
                      "Ocurrió un error al guardar la variación: " +
                        res.data.message
                    );
                  }
                })
                .catch((error) => {
                  toast.error(
                    "Error al guardar la variación: " +
                      (error.response?.data?.message || error.message)
                  );
                });
            } else {
              toast.error(res.data.MensajeError);
            }
          })
          .catch((error) => {
            toast.error(
              "Error al guardar el producto: " +
                (error.response?.data?.message || error.message)
            );
          });
      }
    });
  };

  return (
    <Row justify="center" style={{ marginTop: "5px" }}>
      <Space direction="horizontal">
        <Col span={24} className="site-card-border-less-wrapper">
          <Card
            hoverable
            bordered
            title={
              variation
                ? "Crear Variante (Puedes crear una o más variantes en este formulario, escogiendo los términos diferentes para cada producto)"
                : "Detalles del producto"
            }
            style={{
              borderRadius: "12px",
              margin: 5,
            }}
          >
            <Form
              form={form}
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              initialValues={{
                Codigo: producto.data.Codigo,
                IdCategoria: producto.data.IdCategoria,
                IdSubCategoria: producto.data.IdSubCategoria,
                Descripcion: producto.data.Descripcion,
                PrecioVentaConIva1: producto.data.PrecioVentaConIva,
                PrecioVentaConIva2: producto.data.PrecioVentaConIva2,
                PorcentajeIva: producto.data.PorcentajeIva,
                cat0: producto.data.ParametrizacionContableProducto?.find(
                  (item) => item.Tipo === 0
                )?.NumeroCuenta,
                cat1: producto.data.ParametrizacionContableProducto?.find(
                  (item) => item.Tipo === 1
                )?.NumeroCuenta,
                cat2: producto.data.ParametrizacionContableProducto?.find(
                  (item) => item.Tipo === 2
                )?.NumeroCuenta,
                cat3: producto.data.ParametrizacionContableProducto?.find(
                  (item) => item.Tipo === 4
                )?.NumeroCuenta,
                cat4: producto.data.ParametrizacionContableProducto?.find(
                  (item) => item.Tipo === 5
                )?.NumeroCuenta,
                weight: producto.data.weight,
              }}
            >
              <div style={{ marginBottom: "32px" }}>
                <h3
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    marginBottom: "16px",
                    color: "#555",
                  }}
                >
                  Información Básica
                </h3>
                <Row
                  gutter={[24, 16]}
                  style={{
                    marginLeft: "-12px",
                    marginRight: "-12px",
                    rowGap: "0px",
                  }}
                >
                  {!variation && (
                    <Col xs={24} lg={24}>
                      <Form.Item
                        label="Código de Referencia"
                        name="Codigo"
                        rules={[
                          {
                            required: false,
                            message: "Digita la referencia del producto",
                          },
                        ]}
                        tooltip="Código único para identificar el producto (opcional)"
                      >
                        <Input
                          placeholder="Código de referencia único por variante"
                          maxLength={45}
                          onChange={(value) =>
                            producto.setData({ Codigo: value.target.value })
                          }
                        />
                      </Form.Item>
                    </Col>
                  )}
                  {!variation && (
                    <Col xs={24} lg={24}>
                      <Form.Item
                        label="Nombre del Producto"
                        name="Descripcion"
                        rules={[
                          {
                            required: true,
                            message: "Digite el nombre del producto",
                          },
                        ]}
                        tooltip="Nombre descriptivo del producto"
                      >
                        <Input
                          disabled={variation}
                          placeholder="Ej: Camiseta de Algodón"
                          onChange={(value) =>
                            producto.setData({
                              Descripcion: value.target.value,
                            })
                          }
                        />
                      </Form.Item>
                    </Col>
                  )}
                  {!variation && (
                    <Col xs={24} lg={12}>
                      <Form.Item
                        name="IdCategoria"
                        label="Categoría"
                        rules={[
                          {
                            required: true,
                            message: "Selecciona una categoría",
                          },
                        ]}
                        tooltip="Selecciona la categoría principal del producto"
                      >
                        <Select
                          onChange={(value) =>
                            producto.setData({
                              IdCategoria: value,
                              Categoria: producto.knowName(
                                value,
                                producto.categorys
                              ),
                            })
                          }
                          placeholder="Selecciona una categoría"
                          allowClear
                          showSearch
                          style={{ width: "100%" }}
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          filterSort={(optionA, optionB) =>
                            optionA.children
                              .toLowerCase()
                              .localeCompare(optionB.children.toLowerCase())
                          }
                        >
                          {producto.categorys.map((category) => (
                            <Option key={category.id} value={category.id}>
                              {category.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}
                  {!variation && (
                    <Col xs={24} lg={12}>
                      <Form.Item
                        name="IdSubCategoria"
                        label="Subcategoría"
                        rules={[
                          {
                            required: true,
                            message: "Selecciona una subcategoría",
                          },
                        ]}
                        tooltip="Selecciona una subcategoría"
                      >
                        <Select
                          onChange={(value) =>
                            producto.setData({
                              IdSubCategoria: value,
                              SubCategoria: producto.knowName(
                                value,
                                producto.categorys
                              ),
                            })
                          }
                          placeholder="Selecciona una subcategoría"
                          allowClear
                          showSearch
                          style={{ width: "100%" }}
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          filterSort={(optionA, optionB) =>
                            optionA.children
                              .toLowerCase()
                              .localeCompare(optionB.children.toLowerCase())
                          }
                        >
                          {producto.categorys.map((category) => (
                            <Option key={category.id} value={category.id}>
                              {category.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}
                  {!variation && (
                    <Col xs={24} lg={12}>
                    <Form.Item
                      name="IdMarca"
                      label="Marca"
                      tooltip="Selecciona una marca (opcional)"
                    >
                      <Select
                        onChange={(value) => {
                          const selectedBrand = producto.brands.find((b) => b.id === value);
                          producto.setData({
                            IdMarca: value,
                            Marca: selectedBrand?.name,
                            tags: selectedBrand?.name ? [selectedBrand.name] : [],
                          });
                        }}
                        placeholder="Selecciona una marca"
                        allowClear
                        showSearch
                        style={{ width: "100%" }}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                          optionA.children
                            .toLowerCase()
                            .localeCompare(optionB.children.toLowerCase())
                        }
                      >
                        {producto.brands.map((brand) => (
                          <Option key={brand.id} value={brand.id}>
                            {brand.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                    </Col>
                  )}
                </Row>
              </div>
              {variation && (
                <div style={{ marginBottom: "32px" }}>
                  <h3
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      marginBottom: "16px",
                      color: "#555",
                    }}
                  >
                    Variaciones del Producto
                  </h3>
                  <Row
                    gutter={[24, 16]}
                    style={{
                      marginLeft: "-12px",
                      marginRight: "-12px",
                      rowGap: "0px",
                    }}
                  >
                    {Object.keys(attributes.data).map((key) => {
                      const attribute = attributes.list.find(
                        (attr) => String(attr.id) === String(key)
                      );
                      const attributeName = attribute ? attribute.name : key;

                      return (
                        <Col xs={24} lg={12} key={key}>
                          <Form.Item
                            name={`termselected-${key}`}
                            label={attributeName}
                            rules={[
                              {
                                required: true,
                                message: "Selecciona un término",
                              },
                            ]}
                            tooltip={`Selecciona un término para ${attributeName}`}
                          >
                            <Select
                              onChange={(value) => {
                                settermselected((old) => ({
                                  ...old,
                                  [key]: value,
                                }));
                              }}
                              placeholder="Selecciona un término"
                              allowClear
                              showSearch
                              style={{ width: "100%" }}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                              filterSort={(optionA, optionB) =>
                                optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              }
                            >
                              {attributes.data[key].map((termi, index) => (
                                <Option key={index} value={termi}>
                                  {termi}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              )}

              {variation ? (
                <div style={{ marginBottom: "32px" }}>
                  <h3
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      marginBottom: "16px",
                      color: "#555",
                    }}
                  >
                    Detalles Contables
                  </h3>
                  <ContableItems />
                </div>
              ) : null}

              {variation && (
                <div style={{ marginBottom: "32px" }}>
                  <h3
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      marginBottom: "16px",
                      color: "#555",
                    }}
                  >
                    Precios y Peso
                  </h3>
                  <Row
                    gutter={[24, 16]}
                    style={{
                      marginLeft: "-12px",
                      marginRight: "-12px",
                      rowGap: "0px",
                    }}
                  >
                    <Col xs={24} lg={12}>
                      <Form.Item
                        label="Precio de venta"
                        name="PrecioVentaConIva1"
                        rules={[
                          {
                            required: true,
                            message: "Digite el precio de venta",
                          },
                        ]}
                        tooltip="Precio de venta al público (incluye IVA)"
                      >
                        <Input
                          placeholder="$200.000"
                          type="number"
                          onChange={(value) =>
                            producto.setData({
                              PrecioVentaConIva1: value.target.value,
                              PrecioVentaConIva2: value.target.value,
                              PrecioVentaConIva3: value.target.value,
                            })
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={12}>
                      <Form.Item
                        label="Peso del producto"
                        name="weight"
                        rules={[
                          {
                            required: true,
                            message: "Digite el peso del producto",
                          },
                        ]}
                        tooltip="Peso del producto (ej: 1 kg, 0.3 kg)"
                      >
                        <Input
                          placeholder="(1): kg | (0.3): otros"
                          type="text"
                          onChange={(value) =>
                            producto.setData({ weight: value.target.value })
                          }
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={8}>
                    <Form.Item
                      label="Largo (cm)"
                      name="length"
                      rules={[{ required: true, message: "Digite el largo" }]}
                      tooltip="Largo del producto en centímetros"
                    >
                      <Input
                        placeholder="Ej: 10"
                        type="number"
                        onChange={(e) =>
                          producto.setData({
                            dimensions: {
                              ...producto.data.dimensions,
                              length: e.target.value,
                            },
                          })
                        }
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={8}>
                    <Form.Item
                      label="Ancho (cm)"
                      name="width"
                      rules={[{ required: true, message: "Digite el ancho" }]}
                      tooltip="Ancho del producto en centímetros"
                    >
                      <Input
                        placeholder="Ej: 5"
                        type="number"
                        onChange={(e) =>
                          producto.setData({
                            dimensions: {
                              ...producto.data.dimensions,
                              width: e.target.value,
                            },
                          })
                        }
                      />
                    </Form.Item>
                  </Col>

                  <Col xs={24} lg={8}>
                    <Form.Item
                      label="Alto (cm)"
                      name="height"
                      rules={[{ required: true, message: "Digite el alto" }]}
                      tooltip="Alto del producto en centímetros"
                    >
                      <Input
                        placeholder="Ej: 2"
                        type="number"
                        onChange={(e) =>
                          producto.setData({
                            dimensions: {
                              ...producto.data.dimensions,
                              height: e.target.value,
                            },
                          })
                        }
                      />
                    </Form.Item>
                  </Col>

                  </Row>
                </div>
              )}

              <div style={{ marginBottom: "32px" }}>
                <h3
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    marginBottom: "16px",
                    color: "#555",
                  }}
                >
                  Impuestos
                </h3>
                <Row
                  gutter={[24, 16]}
                  style={{
                    marginLeft: "-12px",
                    marginRight: "-12px",
                    rowGap: "0px",
                  }}
                  justify="start"
                >
                  <Col xs={24} lg={12}>
                    <Form.Item
                      name="PorcentajeIva"
                      label="Porcentaje IVA"
                      rules={[
                        {
                          required: true,
                          message: "Selecciona un porcentaje IVA",
                        },
                      ]}
                      tooltip="Selecciona el porcentaje de IVA aplicable"
                    >
                      <Select
                        onChange={(value) =>
                          producto.setData({ PorcentajeIva: value })
                        }
                        placeholder="Selecciona un porcentaje IVA"
                        allowClear
                        style={{ width: "100%" }}
                      >
                        {TypeIva.map((typeiva) => (
                          <Option key={typeiva.Codigo} value={typeiva.Valor}>
                            {typeiva.Descripcion}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              <Form.Item style={{ textAlign: "center", marginTop: "24px" }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  shape="round"
                  size="large"
                  icon={<PlusCircleFilled />}
                  style={{
                    padding: "0 32px",
                    height: "48px",
                    fontSize: "16px",
                    fontWeight: 500,
                    borderRadius: "10px",
                    transition: "all 0.3s ease",
                  }}
                >
                  {variation ? "Crear variación" : "Crear Producto"}
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Space>
    </Row>
  );
};